import { render, staticRenderFns } from "./VerifyPhone.vue?vue&type=template&id=8e415326&scoped=true&"
import script from "./VerifyPhone.vue?vue&type=script&lang=ts&"
export * from "./VerifyPhone.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyPhone.vue?vue&type=style&index=0&id=8e415326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e415326",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VContainer,VForm,VLayout,VSpacer,VTextField})
